var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>TEEEEEEEEEEEEEEST</div>";
ngModule.run(["$templateCache",function(c){c.put("cardsList/templates/index.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/cardsList/templates/index.html
 ** module id = 556
 ** module chunks = 1
 **/